import { LOCATION_CHANGE } from 'redux-first-history';
import { push } from 'redux-first-history';
import { Action, createAction } from '@reduxjs/toolkit';

import { getStepFromPath, getBasePath, toUrlSlug } from 'utils/stepUrlUtils';

export const locationChange = createAction<{ location: Location; action: Action }>(LOCATION_CHANGE);

export const navigateToStep = (stepKey: string) => {
  const { pathname, search } = window.location;
  const currentStep = getStepFromPath(pathname);

  if (currentStep !== stepKey) {
    const basePath = getBasePath(pathname);
    return push(`${basePath}/${toUrlSlug(stepKey)}${search}`);
  }
};
